<template>
    <div>
        <vs-popup title="Escolha a ação a ser realizada:" 
            :active.sync="active"
            @close="active = false"
            style="border-radius: 10px !important;"
        >
        <div class="flex" style="margin-bottom: 2em;">
            <div class="w-3/12" style="text-align: center; margin-left: 3%;">
                <div class="w-full mt-1 flex justify-center items-center">
                    <span style="width: 10em;">Encerrar Atendimentos:</span>
                </div>
                <div class="w-full mt-2 flex justify-center items-center">
                    <vs-checkbox v-model="close" @click.stop="handleAction('close')" :disabled="!canSee('massive-close')"></vs-checkbox>
                </div>
            </div>

            <div class="w-3/12" style="text-align: center; margin-left: 10%;">
                <div class="w-full mt-1 flex justify-center items-center">
                    <span style="width: 10em;">Transferir para Caixa de Entrada:</span>
                </div>
                <div class="w-full mt-2 flex justify-center items-center">
                    <vs-checkbox v-model="inbox" @click.stop="handleAction('inbox')" :disabled="!inboxActivated || !canSee('massive-transfer-to-inbox')"></vs-checkbox>
                </div>
            </div>

            <div class="w-3/12" style="text-align: center; margin-left: 9%;">
                <div class="w-full mt-1 flex justify-center items-center">
                    <span style="width: 10em;">Transferir Atendimentos:</span>
                </div>
                <div class="w-full mt-2 flex justify-center items-center">
                    <vs-checkbox v-model="transfer" @click.stop="handleAction('transfer')" :disabled="!canSee('massive-transfer-to-user')"></vs-checkbox>
                </div>
            </div>
        </div>

        <div v-if="transfer" style="margin-top: 1em;">
            <div class="w-full text-center flex justify-center items-center">
                <div class="mb-1">
                <div>
                    <span class="text-sm mb-2">Selecione um Atendente (obrigatório):</span>
                </div>

                    <VuePerfectScrollbar
                        style="max-height: 100px;"
                        :key="$vs.rtl"
                        ref="scrollRef"
                        :settings="settings"
                        class="vue-perfect-scrollbar-attendance-contacts"
                    >
                        <v-select
                            class="w-full"
                            v-model="selectedUser"
                            :options="userInfos"
                            @close="resetScroll"
                        />
                    </VuePerfectScrollbar>
                </div>
            </div>
        </div>

        <div v-else-if="inbox" style="margin-top: 1em;">
            <div class="w-full text-center d-flex justify-center items-center">
                <div>
                <div class="mb-1">
                    <span class="text-sm mb-2">Vincular a um Departamento (opcional):</span>
                </div>

                    <VuePerfectScrollbar
                        style="height: 100px;"
                        :key="$vs.rtl"
                        ref="scrollRef"
                        :settings="settings"
                        class="vue-perfect-scrollbar-attendance-contacts"
                    >
                        <v-select
                            label="name"
                            class="w-full"
                            :reduce="departments => departments.id"
                            v-model="departmentId"
                            :options="userDepartments"
                            @close="resetScroll"
                        />
                    </VuePerfectScrollbar>
                </div>
            </div>
        </div>

        <div v-if="close" style="margin-top: 50px !important;"/>
        <vs-divider class="mt-0 mb-0"/>
        <vs-button
            color="primary"
            type="filled"
            class="align-right mr-2 mb-2"
            style="float: right; margin-top: 1em;"
            @click.prevent="sendData"
            :disabled="!close && !transfer && !inbox"
        >
            <span v-if="close">Encerrar</span>
            <span v-else-if="transfer">Transferir</span>
            <span v-else-if="inbox">Transferir para Caixa de Entrada</span>
            <span v-else>Executar</span>
        </vs-button>

        </vs-popup>
    </div>
</template>

<script>
    import { transferManyChatTicket, finishManyChatTicket} from '@/http/requests/chatTicket';
    import moduleUserDepartment from '@/store/userDepartment/moduleUserDepartment';
    //import userDepartment from "@/http/requests/userDepartment";
    import moduleSettings from '@/store/settings/moduleSettings';
    import VuePerfectScrollbar from "vue-perfect-scrollbar";
    import { VTree, VSelectTree } from 'vue-tree-halower';
    import flatPickr from 'vue-flatpickr-component';
    import users from '@/http/requests/user';
    import { hasPermission } from '@/utils';
    import vSelect from 'vue-select';

    export default {
        name: 'BulkTransferComponent',
        props: {
            active: {
                type: Boolean,
                required: true
            },
            contacts: {
                type: Array,
                required: true,
                default: []
            }
        },
        emits: [
            'isActiveFalse'
        ],
        components: {
            flatPickr,
            vSelect,
            VTree,
            VSelectTree,
            VuePerfectScrollbar
        },
        data() {
            return {
                inbox: false,
                close: false,
                transfer: false,
                ticketStatus: '',
                userInfos: [],
                selectedUser: null,
                departmentId: null,
                settings: {
                    maxScrollbarLength: 60,
                    wheelSpeed: 0.50,
                },
                //chatTicketDepartments: []
            }
        },
        watch: {
            async active(value) {
                if (value) {
                    this.userInfos = [];
                    //this.chatTicketDepartments = [];
                    await this.fetch();
                }
                else this.$emit('isActiveFalse');
            },
            departmentId() {
                this.resetScroll();
            },
            selectedUser() {
                this.resetScroll();
            }
        },
        async mounted() {
            if (!moduleUserDepartment.isRegistered) {
                this.$store.registerModule('userDepartment', moduleUserDepartment);
                moduleUserDepartment.isRegistered = true;
            }

            if (!moduleSettings.isRegistered) {
                this.$store.registerModule('settings', moduleSettings)
                moduleSettings.isRegistered = true
            }

            await this.fetch();
        },
        methods: {
            async fetch() {
                //await this.fetchUserDepartmentByChatTicketId();
                await Promise.all(
                    [
                        this.fetchOnlineUsers(),
                        this.$store.dispatch("settings/fetch"),
                        this.$store.dispatch("userDepartment/fetch")
                    ]
                );
            },
            resetScroll() {
                this.$refs.scrollRef.$el.scrollTop = 0;
            },
            handleAction(action) {
                const states = [
                    'inbox',
                    'close',
                    'transfer'
                ]

                const index = states.indexOf(action);
                if (index !== -1) states.splice(index, 1);

                states.forEach( item => this[item] = false );
            },
            async sendData() {
                if ( this.transfer || this.inbox ) {
                    if ( !this.inbox && this.selectedUser === null ) {
                        return this.$vs.notify(
                            {
                                color: 'warning',
                                title: 'Aviso!',
                                text: 'Selecione um usuário!'
                            }
                        );
                    }

                    let newDepartmentId = null;
                    if ( !this.inbox ) {
                        const user = this.userInfos.find( item => item.id === this.selectedUser.id );
                        newDepartmentId = user['userDepartment'] !== null ? user['userDepartment'].id : null;
                    }

                    transferManyChatTicket(
                        JSON.stringify(this.contacts),
                        this.inbox ? null : this.selectedUser.id,
                        this.inbox ? this.departmentId : newDepartmentId
                    )
                    .then(
                        () => {
                            this.active = false;
                            this.$vs.notify(
                                {
                                color: 'success',
                                title: 'Transferência em andamento:',
                                text: `Os atendimentos serão transferidos!`,
                                time: 6000
                                }
                            );
                        }
                    )
                    .catch(
                        error => {
                            console.log(error);
                            return this.$vs.notify(
                                {
                                    color: 'danger',
                                    title: 'Houve algum erro ao efetuar a transferência!'
                                }
                            );
                        }
                    );

                } else {
                    finishManyChatTicket(
                        JSON.stringify(this.contacts)
                    )
                    .then(
                        () => {
                            this.active = false;
                            this.$vs.notify(
                                {
                                    color: 'success',
                                    title: 'Sucesso!',
                                    text: 'Os atendimentos foram encerrados com sucesso!'
                                }
                            );
                        }
                    )
                    .catch(
                        error => {
                            console.log(error);
                            return this.$vs.notify(
                                {
                                    color: 'danger',
                                    title: 'Houve algum erro ao efetuar a transferência!'
                                }
                            );
                        }
                    )
                }

                this.$events.fire('closeModalSelectedContacts', false);
            },
            async fetchOnlineUsers() {
                await users.fetchOnlineUsers(null, null, 1, 10000, '')
                .then(
                    response => {
                        response.data.data.onlineUsers.items.forEach(
                            user => {
                                if (
                                    user.id !== this.activeUserInfo.id /*&&
                                    (
                                        ( this.activeUserInfo.role && this.activeUserInfo.role.name === "administrador" ) ||
                                        ( user.userDepartment && this.chatTicketDepartments.includes(user.userDepartment.id) ) ||
                                        this.chatTicketDepartments.length === 0
                                    )*/
                                ) {
                                    this.userInfos.push(
                                        {
                                            id: user.id,
                                            label: user.name,
                                            email: user.email,
                                            userDepartment: user.userDepartment
                                        }
                                    );
                                }
                            }
                        );
                    }
                );
            },
            /*async fetchUserDepartmentByChatTicketId() {
                await userDepartment.fetchUserDepartmentByChatTicketId(JSON.stringify(this.contacts))
                .then(
                    response => {
                        this.chatTicketDepartments = response.data.data.userDepartmentByChatTicketIdQuery;
                        if (
                            this.chatTicketDepartments.length > 0
                            && this.activeUserInfo.role
                            && this.activeUserInfo.role.name !== "administrador"
                        ) {
                            return this.$vs.notify(
                                {
                                    color: 'warning',
                                    title: 'Aviso!',
                                    text: 'Há usuários ocultos para transferência pois você selecionou atendimentos vinculados a um ou mais departamentos!',
                                    time: 10000
                                }
                            );
                        }
                    }
                )
            }*/
            canSee(action) {
                return hasPermission(`${this.$route.name}-${action}`);
            }
        },
        computed: {
            activeUserInfo() {
                return this.$store.state.AppActiveUser;
            },
            userDepartments() {
                return this.$store.state.userDepartment.userDepartments;
            },
            inboxActivated() {
                return !Boolean(Number(this.$store.state.settings.settings.relate_chat_tickets_to_next_user));
            }
        }
    }
</script>

<style lang="scss">
.vue-perfect-scrollbar-attendance-contacts {
    position: relative;
    margin: auto;
    width: 100%;
    height: 23rem;
}
</style>